define(["exports", "./utils", "hyperhtml", "./pubsubhub"], function (_exports, _utils, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["", ""]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/contrib";
  _exports.name = name;

  async function run(conf) {
    const ghContributors = document.getElementById("gh-contributors");

    if (!ghContributors) {
      return;
    }

    if (!conf.github) {
      const msg = "Requested list of contributors from GitHub, but " + "[`github`](https://github.com/w3c/respec/wiki/github) configuration option is not set.";
      (0, _pubsubhub.pub)("error", msg);
      return;
    }

    const editors = conf.editors.map(editor => editor.name);
    await showContributors(editors, conf.githubAPI);
  }
  /**
   * Show list of contributors in #gh-contributors
   * @param {string[]} editors
   * @param {string} apiURL
   */


  async function showContributors(editors, apiURL) {
    const elem = document.getElementById("gh-contributors");
    if (!elem) return;
    elem.textContent = "Fetching list of contributors...";
    const contributors = await getContributors();

    if (contributors !== null) {
      toHTML(contributors, elem);
    } else {
      elem.textContent = "Failed to fetch contributors.";
    }

    async function getContributors() {
      const {
        href: url
      } = new URL("contributors", apiURL);

      try {
        const res = await (0, _utils.fetchAndCache)(url);

        if (!res.ok) {
          throw new Error("Request to ".concat(url, " failed with status code ").concat(res.status));
        }
        /** @type {Contributor[]} */


        const contributors = await res.json();
        return contributors.filter(user => !editors.includes(user.name || user.login));
      } catch (error) {
        (0, _pubsubhub.pub)("error", "Error loading contributors from GitHub.");
        console.error(error);
        return null;
      }
    }
  }
  /**
   * @typedef {{ name?: string, login: string }} Contributor
   * @param {Contributor[]} contributors
   * @param {HTMLElement} element
   */


  function toHTML(contributors, element) {
    const sortedContributors = contributors.sort((a, b) => {
      const nameA = a.name || a.login;
      const nameB = b.name || b.login;
      return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
    });

    if (element.tagName === "UL") {
      (0, _hyperhtml.default)(element)(_templateObject(), sortedContributors.map(({
        name,
        login
      }) => "<li><a href=\"https://github.com/".concat(login, "\">").concat(name || login, "</a></li>")));
      return;
    }

    const names = sortedContributors.map(user => user.name || user.login);
    element.textContent = (0, _utils.joinAnd)(names);
  }
});
//# sourceMappingURL=contrib.js.map